const key = `onboardingWidgetHiddenForContractId`;

export function isWidgetVisible(contractId: string) {
  return localStorage.getItem(key + contractId) !== 'true';
}

export function hideWidget(contractId: string) {
  localStorage.setItem(key + contractId, 'true');
}
